import { getAuth, onAuthStateChanged } from "firebase/auth";
import { app } from "./firebaseConfig";
import React, { useEffect, useState, useRef } from "react";

const auth = getAuth(app);
const IFRAME_ORIGIN = "https://ba-artworks.com/web-contents/shin-yu/shinyu-salvage.html";
const ORIGIN = "https://ba-artworks.com"
const API_ENDPOINT = "https://bad-assort.com/api/recovery-shinyu";

export default function Shinyu() {
  const [user, setUser] = useState(auth.currentUser);
  const [isVisible, setVisible] = useState<boolean>(false);
  const [loading, setLoading] = useState(false);
  const iframeRef = useRef<HTMLIFrameElement>(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      setUser(user);
    });
    return () => unsubscribe();
  });

  const handleMessage = async (event: MessageEvent) => {
    if (event.origin !== ORIGIN) return; // セキュリティチェック

    try {
      console.log("データ取得成功:", event.data);
      await sendData(event.data);
    } catch (error) {
      console.error("データ取得エラー:", error);
    } finally {
      setLoading(false);
      alert("データの読み込みが完了しました\nブラウザに保存されているプレイデータに対応した実績を取得しました\nページをリロードしてください")
      window.removeEventListener("message", handleMessage);
    }
  };

  const fetchDataAndSend = () => {
    if (loading) return;
    setLoading(true);

    window.addEventListener("message", handleMessage);

    const popup = window.open(IFRAME_ORIGIN, "popupWindow", "width=500,height=500");

    if (!popup) {
      alert("ポップアップがブロックされました。ブロックを解除して再度お試しください。");
      return;
    }
    /*
    if (iframeRef.current) {
      try {
        iframeRef.current.contentWindow?.postMessage("get", STORAGE_ORIGIN);
      } catch (error) {
        console.error("iframe 経由の通信に失敗:", error);
        setLoading(false);
        window.removeEventListener("message", handleMessage);
      }
    }*/
  };

  const sendData = async (data: any) => {
    try {
      const response = await fetch(API_ENDPOINT, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ userId: user?.uid, shinyuStatus: data }),
      });

      if (!response.ok) throw new Error("API request failed");

      console.log("success send data");
    } catch (error) {
      console.error("error send data:", error);
    }
  };

  const disp = () => {
    setVisible(true);
  }

  const collapse = () => {
    setVisible(false);
  }

  return (
    <>
      <button id="dispShinyu" onClick={disp}>「神佑」実績の取得はこちら</button>
      <div className="form-back" style={{ zIndex: `${isVisible ? 1500 : -1}`, opacity: `${isVisible ? 1 : 0}` }}>
        <form id="shinyu-form">
          <p style={{ color: "red", fontWeight: "bold" }}>【2026/2 更新】 現在、移行に伴うシステム調整のため本画面からの対応を停止中です。</p>
          <p>神佑の実績の更新を希望される方は、進捗状況(通過した章またはED番号)とともにお問い合わせフォームよりお問い合わせください。</p>
          <ul style={{ textDecoration: "line-through", color: "gray" }}>
            <li>超長編Web謎解きゲーム「神佑」の進捗を条件とする実績の解放ができます。</li>
            <li>必ず解いたブラウザと同じブラウザで開いてください。</li>
            <li>実行ボタンを押すとポップアップが出ます。ブラウザの設定でポップアップをブロックしている場合は解除してください。</li>
            <li>全進捗リセットボタンを使用している場合、一部の実績が解放されない場合があります。</li>
            <li>処理には数秒～1分程度かかる場合があります。処理が完了すると通知が出ますので、画面は閉じずにお待ちください。</li>
            <li>何らかの理由でブラウザにデータが残っていない場合、実績の解放ができません。個別にお問い合わせいただくことで実績データの取得ができる場合がありますので、contact.badassort@gmailまでご連絡ください。</li>
          </ul>
          <p>
            <button type="button" onClick={() => null/*fetchDataAndSend*/} disabled={loading}>
              {loading ? "処理中です..." : "実行"}
            </button>
            <button type="button" onClick={collapse}>閉じる</button></p>
        </form>
      </div>
    </>
  )
}
